module.exports = __webpack_public_path__ + "img/double-right-arrow.eb0d5281.svg";